document.addEventListener('DOMContentLoaded', () => {
  try {
    const modal = document.getElementById('custom-bundle-modal');
    const closeBtn = document.querySelector('.custom-bundle-modal-close');
    const slots = document.querySelectorAll('.custom-bundle-slot-inner[data-open-modal]');
    const searchInput = document.getElementById('custom-bundle-search');
    let selectedProductsInput = document.getElementById('custom-bundle-selected-products');

    if (!selectedProductsInput) {
      const form = document.getElementById('custom-bundle-form') || document.querySelector('form');
      selectedProductsInput = document.createElement('input');
      selectedProductsInput.type = 'hidden';
      selectedProductsInput.name = 'properties[selected_products]';
      selectedProductsInput.id = 'custom-bundle-selected-products';
      selectedProductsInput.value = '';
      if (form) form.appendChild(selectedProductsInput);
      else document.body.appendChild(selectedProductsInput);
    }

    let activeSlotIndex = null;

    if (modal) {
      modal.style.display = 'none';
      modal.setAttribute('aria-hidden', 'true');
    }

    // Bu fonksiyonu saklıyoruz, gerektiğinde başka yerde kullanabilirsin
    function escapeHtml(text) {
      if (!text && text !== 0) return '';
      return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function updateSelectedProductsInput() {
      const slotInners = document.querySelectorAll('.custom-bundle-slot-inner');
      const selectedArr = [];

      slotInners.forEach(slotInner => {
        const vendorEl = slotInner.querySelector('.custom-bundle-slot-vendor');
        const titleEl = slotInner.querySelector('.custom-bundle-slot-name');

        const vendor = vendorEl ? vendorEl.textContent.trim() : '';
        const title = titleEl ? titleEl.textContent.trim() : '';

        if (title) {
          selectedArr.push(vendor ? `${vendor} - ${title}` : title);
        }
      });

      selectedProductsInput.value = selectedArr.join(', ');
    }

    function renderProductsForSlot(slotIndex) {
      const products = window.customBundleCollections[slotIndex] || [];
      const modalGrid = document.getElementById('custom-bundle-modal-grid');
      modalGrid.innerHTML = '';

      products.forEach(product => {
        const div = document.createElement('div');
        div.className = 'custom-bundle-product-option';
        div.dataset.id = product.id;
        div.dataset.title = product.title;
        div.dataset.vendor = product.vendor;
        div.dataset.image = product.image;

        // Burada escapeHtml kaldırıldı, HTML etiketleri render edilecek!
        div.innerHTML = `
          <div class="custom-bundle-product-option-img">
            <img src="${product.image}" alt="${product.title}">
          </div>
          <div class="custom-bundle-product-option-info">
            <div class="custom-bundle-product-option-vendor">${product.vendor}</div>
            <h5 class="option-name">${product.title}</h5>
          </div>
          <div class="custom-bundle-product-option-arrow">
            <img src="https://cdn.shopify.com/s/files/1/0042/7160/3782/files/drop-down-icon.png?v=1660749502" alt="expand">
          </div>
        `;

        div.addEventListener('click', () => {
          updateSlotProduct(slotIndex, product);
          modal.style.display = 'none';
          modal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
          activeSlotIndex = null;
        });

        modalGrid.appendChild(div);
      });
    }

    function updateSlotProduct(slotIndex, product) {
      const slot = document.querySelector(`.custom-bundle-slot[data-slot="${slotIndex}"]`);
      if (!slot) return;

      const slotInner = slot.querySelector('.custom-bundle-slot-inner');
      // Burada escapeHtml kaldırıldı, HTML etiketleri render edilecek!
      slotInner.innerHTML = `
        <div class="custom-bundle-slot-img">
          <img src="${product.image}" alt="${product.title}">
        </div>
        <div class="custom-bundle-slot-info">
          <div class="custom-bundle-slot-vendor">${product.vendor}</div>
          <h4 class="custom-bundle-slot-name">${product.title}</h4>
        </div>
        <div class="custom-bundle-slot-arrow">
          <img src="https://cdn.shopify.com/s/files/1/0042/7160/3782/files/drop-down-icon.png?v=1660749502" alt="expand">
        </div>
      `;

      updateSelectedProductsInput();
    }

    updateSelectedProductsInput();

    slots.forEach((slotInner, index) => {
      slotInner.addEventListener('click', (e) => {
        e.preventDefault?.();
        activeSlotIndex = index;

        if (!modal) return;

        renderProductsForSlot(activeSlotIndex);

        modal.style.display = 'flex';
        modal.setAttribute('aria-hidden', 'false');

        if (searchInput) searchInput.value = '';
        document.body.style.overflow = 'hidden';
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault?.();
        if (!modal) return;
        modal.style.display = 'none';
        modal.setAttribute('aria-hidden', 'true');
        activeSlotIndex = null;
        document.body.style.overflow = '';
      });
    }

    if (modal) {
      modal.addEventListener('click', (e) => {
        if (e.target === modal) {
          modal.style.display = 'none';
          modal.setAttribute('aria-hidden', 'true');
          activeSlotIndex = null;
          document.body.style.overflow = '';
        }
      });
    }

    // Arama fonksiyonu: modal grid içindeki ürünleri filtreler
    if (searchInput) {
      searchInput.addEventListener('input', (e) => {
        const query = (e.target.value || '').toLowerCase().trim();
        const options = document.querySelectorAll('.custom-bundle-product-option');

        options.forEach(opt => {
          const title = (opt.dataset.title || '').toLowerCase();
          const vendor = (opt.dataset.vendor || '').toLowerCase();
          opt.style.display = (title.includes(query) || vendor.includes(query)) ? 'flex' : 'none';
        });
      });
    }

    // Form submit olduğunda seçili ürünleri güncelle
    document.addEventListener('submit', (e) => {
      updateSelectedProductsInput();
    }, true);

  } catch (err) {
    console.error('custom-bundle-selector error:', err);
  }
});
